import { render, staticRenderFns } from "./AudienceTagFilter.vue?vue&type=template&id=4feda082"
import script from "./AudienceTagFilter.vue?vue&type=script&lang=js"
export * from "./AudienceTagFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports